<template>
  <div id="bundle_details" class="gray-gradient-bottom0 bundles-min">
    <div class="social-nav filter-blur-50 border-bottom-white-1-50">
      <div class="nameContainer" style="width: 100vw">
        <router-link to="/personal" class="d-flex">
          <div class="homeIcon">
            <a><img src="../../assets/icons/homeIcon.svg" height="20px" width="20px"></a>
          </div>
        </router-link>
        <div class="arrowIcon">
          <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">
        </div>
        <router-link :to="$route.params.type === 'segment' ? '/products/segment-products' : '/bundles'" class="d-flex">
          <div class="bundleTitle">
            {{ $route.params.type === 'segment' ? $t('segmentedProducts.secondaryTitle') : Bundles }}
          </div>
        </router-link>
        <div class="arrowIcon">
          <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">
        </div>
        <div class="titleName">{{ bundlesDetalis }}</div>
      </div>
    </div>
    <div class="flex-center cont-pad" style="padding-bottom: 4vw" v-if="fetched && !error"
      :class="lang === 'ar' ? 'arabicDirecton' : ''">
      <div class="w-100">
        <div class="row data-container" :class="this.$lang === 'ar' ? 'ar-cont' : 'en-cont'">
          <div class="col-lg-5 col-12 d-flex align-items-center"
            :class="this.$lang === 'ar' ? 'justify-content-start padding-ar' : 'justify-content-end padding-en'">
            <img class="d-img-lg w-100 h-100 radius-28 max-w-h bundle-details-img" :src="info.main.image">
          </div>
          <div class="col-lg-7 col-12 " :class="this.$lang === 'ar' ? 'descriptionDir' : ''">
            <div style="margin: 0 4vw;" :class="this.$lang === 'ar' ? 'text-right' : 'text-left'">
              <div class="main-title pt-lg-5 py-0">{{ info.main.title }}</div>
              <img class="d-img-sm w-100 radius-28 max-h" :src="info.main.image">
              <div class="bundle-price-container mt-md-2 mt-2">
                <span class="price">{{ info.main.price }}</span>/<span style="font-size: 7px">&nbsp;</span><span
                  class="unit" :class="lang === 'ar' ? 'pr-1' : ''">{{ info.main.unit }}</span>
                <label class="switch" v-if="this.$store.state.selectedNumber !== null && $route.params.type === 'bundle'">
                  <input @click="activate" v-model="active" type="checkbox">
                  <span class="slider" :class="active ? '' : 'inactive'"></span>
                  <div :style="{ transform: active ? 'translateX(1.2em)' : 'translateX(0em)' }" class="slider-border">
                  </div>
                </label>
              </div>
              <div class="description click-address" v-html="info.main.description"></div>
            </div>
          </div>
        </div>
        <div v-for="(item, i) in info.slider" :key="i" class="d-inline-block" style="margin-top: 20px">
          <div class="bundle d-inline-block" v-if="item.description !== '' && item.description !== null">
            <div class="bundle-basic gray-gradient-bottom0 bundle-shadow flex-center">
              <div class="">
                <div class="card-icon">
                  <img :src="require(`../../assets/icons/${item.icon}`)">
                </div>
                <div class="card-title" :class="lang === 'ar' ? 'descriptionDir' : ''">
                  {{ item.title }}
                </div>
                <div class="card-description">
                  {{ item.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <Error v-if="error" />
      <Loader v-if="!fetched && !error" />
    </div>
    <!--    <Insure @refresh="$emit('refresh')" @close="close" :id="data.id" method="post" type="bundles" v-if="change" :checked="checked" />-->
    <InsureActivation @refresh="refresh" @close="close" :id="Number(id)" method="post" type="bundles" v-if="ensure"
      :active="info.main.isActive" />
  </div>
</template>

<script>
import $ from 'jquery'
import BundlesDetailsRepository from '../../repositories/BundleDetailsRepository'
import SegmentBundleById from '../../repositories/SegmentBundleById'
import gc from '../../utils/gc'
import Loader from '../../components/LoaderBtn/Loader'
import Error from '../../components/errorHandle/Error'
import InsureActivation from '../../components/dialogs/InsureActivation'
export default {
  name: 'BundleDetails',
  components: { InsureActivation, Loader, Error },
  data () {
    return {
      showCode: false,
      active: false,
      ensure: false,
      lang: this.$lang,
      Bundles: this.$t('Bundles.title'),
      bundlesDetalis: this.$t('Bundles.details'),
      segmentRepo: new SegmentBundleById(this.$route.params.id),
      test: false,
      fetched: false,
      error: false,
      bundleRepo: new BundlesDetailsRepository(),
      id: -1,
      base: gc.baseUrl,
      info: {
        main: {
          title: '', description: '', price: '', unit: '', image: '', back: ''
        },
        slider: [
          { title: '', description: '', icon: 'internet.svg' },
          { title: '', description: '', icon: 'calls.svg' },
          { title: '', description: '', icon: 'SMS.svg' },
          { title: '', description: '', icon: 'code.svg' },
          { title: '', description: '', icon: 'validation.svg' }
        ]
      }
    }
  },
  created () {
    this.id = this.$route.params.id
    this.$store.state.activeSectionNav = this.$route.params.type === 'segment' ? 1 : 2
    // eslint-disable-next-line valid-typeof
    this.$route.params.type === 'segment' ? this.fetchDetails(this.segmentRepo) : this.fetchDetails()
    this.showCode = this.$route.params.type === 'bundle'
  },
  mounted () {
    this.arabic()
    // At change the main account, we should go to home page to reload bundles with selected gsm
    this.$watch(() => {
      return this.$store.state.selectedNumber
    }, (val) => {
      this.goToHome()
    })
  },
  methods: {
    refresh () {
      this.fetched = false
      this.error = false
      this.fetchDetails()
    },
    activate () {
      this.ensure = true
      // this.active = this.info.main.isActive
    },
    close () {
      this.ensure = false
      this.active = this.info.main.isActive
    },
    async fetchDetails (obj = this.bundleRepo) {
      try {
        const response = await obj.getBundleDetails(this.id, this.$store.state.selectedNumber)
        if (response.status === 200) {
          if (this.showCode) {
            this.info = {
              main: {
                title: response.data.title,
                description: response.data.html,
                price: response.data.price === 0 ? this.$t('free') : response.data.price + this.$t('Bundles.sp'),
                unit: `${response.data.validity === 1 ? '' : response.data.validity} ${response.data.type === 0 ? this.$t('Bundles.day') : response.data.type === 1 ? this.$t('Bundles.week') : this.$t('Bundles.month')}`,
                image: this.base + '/' + response.data.image,
                back: 'bundleDetails.png',
                isActive: response.data.isActive === 1
              },
              slider: [{
                title: response.data.dataSize + ' ' + response.data.dataUnit,
                description: response.data.dataNote,
                icon: 'internet.svg'
              }, {
                title: response.data.minuteCount + this.$t('Bundles.min'),
                description: response.data.minuteNote,
                icon: 'calls.svg'
              }, {
                title: response.data.smsCount + this.$t('Bundles.sms'),
                description: response.data.smsNote,
                icon: 'SMS.svg'
              },
              {
                title: this.$t('Bundles.activation'),
                description: this.$t('Bundles.dial') + response.data.activationCode + this.$t('Bundles.activate'),
                icon: 'code.svg'
              },
              {
                title: this.$t('Bundles.validation'),
                description: `${this.$t('Bundles.validFor')}${response.data.validity} ${response.data.type === 0 ? this.$t('Bundles.day') : response.data.type === 1 ? this.$t('Bundles.week') : this.$t('Bundles.month')}${this.$t('Bundles.renewed')}`,
                icon: 'validation.svg'
              }
              ]
            }
          } else {
            this.info = {
              main: {
                title: response.data.title,
                description: response.data.html,
                price: response.data.price === 0 ? this.$t('free') : response.data.price + this.$t('Bundles.sp'),
                unit: `${response.data.validity === 1 ? '' : response.data.validity} ${response.data.type === 0 ? this.$t('Bundles.day') : response.data.type === 1 ? this.$t('Bundles.week') : this.$t('Bundles.month')}`,
                image: this.base + '/' + response.data.image,
                back: 'bundleDetails.png',
                isActive: response.data.isActive === 1
              },
              slider: [{
                title: response.data.dataSize + ' ' + response.data.dataUnit,
                description: response.data.dataNote,
                icon: 'internet.svg'
              }, {
                title: response.data.minuteCount + this.$t('Bundles.min'),
                description: response.data.minuteNote,
                icon: 'calls.svg'
              }, {
                title: response.data.smsCount + this.$t('Bundles.sms'),
                description: response.data.smsNote,
                icon: 'SMS.svg'
              },
              {
                title: this.$t('Bundles.validation'),
                description: `${this.$t('Bundles.validFor')}${response.data.validity} ${response.data.type === 0 ? this.$t('Bundles.day') : response.data.type === 1 ? this.$t('Bundles.week') : this.$t('Bundles.month')}${this.$t('Bundles.renewed')}`,
                icon: 'validation.svg'
              }
              ]
            }
          }
          this.active = this.info.main.isActive
          this.fetched = true
        } else {
          this.fetched = false
          this.error = true
        }
      } catch (e) {
        this.fetched = false
        this.error = true
        console.log(e)
      }
    },
    arabic () {
      if (this.$lang === 'ar') {
        $('.social-nav, .bundleTitle, .titleName').css('transform', 'rotateY(180deg)')
        $('.bundleTitle').css('font-family', 'Mtn-arabic-regular')
        $('.titleName').css('font-family', 'Mtn-arabic-bold')
        $('#bundle_details .cont-pad').addClass('arabicDirecton')
      }
    },
    goToHome () {
      // this.fetched = false
      // this.error = false
      // this.fetchDetails()
      if (this.$route.params.type === 'segment') {
        this.$router.push('/products/segment-products')
      } else {
        this.$router.push('/bundles')
      }
    }
  },
  watch: {
    fetched () {
      this.$lang === 'ar' ? $('#bundle_details .card-title').css('font-family', 'Mtn-arabic-bold') && $('#bundle_details .card-title').css('direction', 'rtl') && $('#bundle_details .main-title').css({ 'font-family': 'Mtn-arabic-bold', 'text-align': 'right' }) && $('.bundle-price-container').css('justify-content', 'start') && $('#bundle_details .description').css({ 'text-align': 'right', 'font-family': 'Mtn-arabic-regular' }) && $('#bundle_details .card-description').css('font-family', 'Mtn-arabic-regular') && $('#bundle_details .card-description').css('direction', 'rtl') &&
        $('.price').css('font-family', 'Mtn-arabic-bold') && $('.price').css('direction', 'rtl') && $('.price').css('margin-bottom', '11px') && $('.unit').css('font-family', 'Mtn-arabic-bold') && $('.price').css('margin-left', '3px') : $('#bundle_details .card-title').css('font-family', 'Mtn-bold-italic') && $('.price').css('font-family', 'Mtn-bold') && $('.price').css('margin-bottom', '4px') && $('.unit').css('font-family', 'Mtn-bold-italic') && $('#bundle_details .main-title').css({ 'font-family': 'Mtn-bold-italic', 'text-align': 'left' }) && $('#bundle_details .card-description').css('font-family', 'Mtn-regular') && $('.price').css('margin-right', '3px')
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/sass/main";

.padding-en {
  padding: 0px 4vw 0vw 0vw;
}

.padding-ar {
  padding: 0px 0vw 0vw 4vw;
}

.bundle-details-img {
  width: 100% !important;
  height: auto !important;
  //width: 484px !important;
  //height: 240px !important;
}

@media screen and (max-width: 992px) {
  .d-img-sm {
    max-width: 484px !important;
  }
}

.ar-cont {
  flex-direction: row !important;
}

.en-cont {
  flex-direction: row-reverse !important;
}

#bundle_details {
  //padding-top: 6.5rem !important;
  padding-top: 168px !important;
}

.loader,
.error-container {
  min-height: calc(100vh - 454.3px) !important;
}

.loader {
  padding: 5rem 0;
}

.bundles-min {
  min-height: calc(100vh - 285.3px) !important;
}

.bundles-fetching {
  min-height: calc(100vh - 454.3px) !important;
  padding-top: 100px;
}

#bundle_details .cont-pad {
  padding-top: 30px;
  background-image: url("../../assets/icons/bundlesBackground.svg");
  background-position-x: right;
}

.arabicDirecton {
  background-position-x: left !important;
}

.data-container {
  //flex-direction: row-reverse;
  margin-top: 2rem;
  margin-bottom: 30px;
}

.bundle-price-container {
  display: flex;
  align-items: center;
}

.main-title {
  font-size: 30px !important;
  font-style: italic;
}

.description {
  margin: 1.5rem 0 0rem 0 !important;
}

.price {
  color: $--black;
}

.unit {
  font-style: italic;
  font-size: 12px !important;
}

.bundle {
  margin: 1vw 2vw;
  min-width: 169px;
  min-height: 169px;
  max-width: 247px;
  max-height: 247px;
  width: 15.2vw;
  height: 15.2vw;
}

.bundle-basic {
  padding: 0 0.5rem;
  border: 3px solid rgba(255, 255, 255, 0.1);
  border-radius: 25px;
  width: 100%;
  height: 100%;
}

.card-icon {
  margin-bottom: 0.7rem;
}

.card-icon img {
  width: 55px;
  height: 33px;
}

.card-title {
  font-size: 19px;
  //font-family: Mtn-bold;
  font-style: italic;
  color: $--yellow;
  margin-bottom: 0.7rem;
}

.card-description {
  font-size: 13px;
  height: 42px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.max-w-h {
  //max-width: 532px;
  //max-height: 299px;
}

.max-h {
  //margin-top: 10px;
  //max-height: 459px !important;
}

@media screen and (max-width: 600px) {
  .bundle {
    margin: 1vw 3vw !important;
  }
}

@media screen and (max-width: 992px) {
  .d-img-lg {
    display: none;
  }

  .price {
    //margin: 0.5rem !important;
  }

  .main-title {
    margin-bottom: 1rem !important;
  }
}

@media screen and (min-width: 992px) {
  .d-img-sm {
    display: none;
  }
}

.social-nav {
  //background: rgba(212, 212, 212, 0.45);
  //background-color: $--light-white;
  height: 50px;
  //box-shadow: 10px 10px 30px 0px rgba(0, 0, 0, 0.1) !important;
  background: rgba(242, 242, 242, 1);
  box-shadow: 0 15px 25px rgba(0, 0, 0, 0.1);
  //backdrop-filter: blur(40px);
  margin: 0px 0px;
  display: flex;
  position: fixed;
  z-index: 10;
  z-index: 210;
  top: 110px;
}

.nameContainer {
  display: flex;
  padding: 0 4vw 0 3.2vw;
}

.homeIcon {
  cursor: pointer;
}

.homeIcon,
.arrowIcon,
.titleName {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1vw;
}

.titleName {
  width: max-content;
  color: $--yellow;
  font-family: Mtn-bold;
  text-decoration: underline;
}

.bundleTitle {
  width: max-content;
  font-family: Mtn-regular;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1vw;
}

.backArrow {
  width: 35px;
  height: 35px;
  margin-bottom: 50px;
}

.descriptionDir {
  direction: rtl !important;
}

.rotateArrow {
  transform: rotateY(180deg);
}

label {
  margin: 0 1rem;
}

/*--- switch button ----*/
/* The switch - the box around the slider */
.switch {
  font-size: 17px;
  position: relative;
  display: inline-block;
  width: 2.8em;
  height: 1.5em;
  border-radius: 50px;
  box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.08)
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  border: 2px solid $--yellow;
  border-radius: 50px;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.inactive {
  border: 2px solid #6A6A6A;
}

.inactive.slider:before {
  background-color: #6A6A6A;
}

.slider:before {
  position: absolute;
  content: "";
  height: 1em;
  width: 1em;
  left: 0.2em;
  bottom: 0.14em;
  background-color: $--yellow;
  border-radius: inherit;
  transition: all 0.4s cubic-bezier(0.23, 1, 0.320, 1);
}

.slider-border {
  height: 1em;
  width: 1em;
  border: .8px solid #ffffff;
  border-radius: 50%;
  position: absolute;
  left: 0.32em;
  bottom: 0.25em;
  filter: blur(1px);
  transition: all 0.4s cubic-bezier(0.23, 1, 0.320, 1);
  cursor: pointer;
}

.switch input:checked+.slider:before {
  transform: translateX(1.2em);
}

/*---------------------------------*/</style>
